import React, { useEffect } from 'react';

interface SponsorModalProps { onClose: () => void; }

export function SponsorModal({ onClose }: SponsorModalProps) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onMouseDown={onClose} role="presentation">
      <section className="modal" onMouseDown={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="sponsor-title">
        <div className="modal-header">
          <h2 id="sponsor-title">赞助支持 VIVA GAME</h2>
          <button className="close-btn" onClick={onClose} aria-label="关闭">×</button>
        </div>
        <div className="modal-body">
          <p className="sponsor-intro">感谢支持 VIVA 网页游戏计划。请使用微信或支付宝扫描下方二维码进行赞助支持。</p>
          <div className="qr-grid">
            <article className="qr-card">
              <img src="./assets/images/qr-wechat.png" alt="微信赞助二维码" />
              <strong>微信赞助</strong><span>微信扫码支持</span>
            </article>
            <article className="qr-card">
              <img src="./assets/images/qr-alipay.png" alt="支付宝赞助二维码" />
              <strong>支付宝赞助</strong><span>支付宝扫码支持</span>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
}
